import { render } from "./TablePane.vue?vue&type=template&id=4567ab22&ts=true"
import script from "./TablePane.vue?vue&type=script&lang=ts"
export * from "./TablePane.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/workshop/teambition-frontend/node_modules/.pnpm/vue-loader@16.8.3_6zog4g7lmcedlfqueoidvwcx7q/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__